module.exports = __webpack_public_path__ + "img/tip_bg2.1b9f9574.png";